<script setup>

import {computed, ref} from "vue";

const props = defineProps({
    data: {
        type: [Object, null],
        required: false,
        default: null,
    },
    page: {
        type: Number,
        required: false,
        default: 1,
    }
});

const emit = defineEmits(['update:page', 'changed']);

const pageRef = ref(null);

const pageProxy = computed({
    get: () => pageRef.value ?? props.page ?? 1,
    set: (page) => {
        if(page >= 1 && page <= props.data?.meta?.last_page && page !== pageProxy.value) {
            pageRef.value = page;
            emit('update:page', pageRef.value);
            emit('changed', pageRef.value);
        }
    }
});


</script>

<template>
    <div v-if="data?.meta?.last_page > 1">
        <div class="py-2">
            <div class="w-full flex flex-wrap justify-center">
                <template v-for="i in data?.meta?.last_page" :key="`e-pagination-element-${i}`">
                    <div
                        v-if="pageProxy === i"
                        class="mx-[2px] px-4 py-3 text-sm leading-4 border rounded bg-blue-700 !text-white cursor-not-allowed"
                    >{{ i }}</div>
                    <button v-else
                            type="button"
                            class="mx-[2px] px-4 py-3 text-sm leading-4 border rounded hover:bg-gray-50 focus:border-blue-900 focus:text-blue-900 cursor-pointer"
                            @click="pageProxy = i"
                    >{{ i }}</button>
                </template>
            </div>
        </div>
    </div>
</template>
